<template>
	<div>
		<compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="info">
			<compFormQuery v-if="type==='query'" class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
			<compFormEdit v-else ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
			<vButtonGroup slot="footer"  v-if="isQuery">
				<vButton v-if="type!=='query'" theme="primary" @click="submitSave">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
				<vButton v-if="type!=='query'&&getId" theme="error" @click="submitSave('complete')">{{$t('global.common.finish', { defaultValue: '完成' })}}</vButton>
				<vButton @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
			</vButtonGroup>

		</compWrapper>
		<compWrapper :title="$t('fbb.alloment.plan_box_detail', { defaultValue: '调拨计划装箱明细' })" theme="primary" v-if="type!=='query'&&getId">
			<div class="text-right margin-15">
				<vButton theme="primary" @click="handleModal('boxing')">{{$t('fbb.alloment.query_box_detail', { defaultValue: '查看装箱明细' })}}</vButton>
			</div>
			<vTableSimple class="margin-layout" :columns="getProcuctColumns" :data="productList"></vTableSimple>
		</compWrapper>
		<compWrapper :title="$t('fbb.alloment.out_bound_detail', { defaultValue: '出库明细' })" theme="primary" v-if="getId">
			<template v-if="type!=='query'">
				<vAlert theme="info" class="margin-layout">{{$t('fbb.alloment.tip_4', { defaultValue: '若存在箱码数据，可只填写箱码；若无箱码数据，则需填写ERP SKU及数量' })}}</vAlert>
				<vButtonGroup class="margin-layout">
					<vButton theme="primary" @click="onceSubmit">{{$t('fbb.alloment.click_outbound', { defaultValue: '一键出库' })}}</vButton>
					<vButton theme="info" @click="handleModal('upload')">{{$t('fbb.alloment.import_outbound_detail', { defaultValue: '导入出库明细' })}}</vButton>
				</vButtonGroup>
				<compFormEdit ref="bound" class="margin-layout" :formdata="getOutbound" v-model="boundFormData"></compFormEdit>
				<vButtonGroup class="margin-layout">
					<vButton theme="primary" @click="addItem">{{$t('fbb.alloment.add_by_one', { defaultValue: '逐个添加' })}}</vButton>
					<vButton theme="gray" @click="removeItems">{{$t('fbb.alloment.delete_data', { defaultValue: '删除数据' })}}</vButton>
					<vButton theme="gray" @click="clearAll">{{$t('fbb.alloment.clear_data', { defaultValue: '清空数据' })}}</vButton>
				</vButtonGroup>
			</template>
			<vTableSimple
				class="margin-layout"
				:columns="getOutColumns"
				:data="dataList"
				@on-check-change="setCheckData"
			></vTableSimple>
		</compWrapper>
		<compLog v-if="type==='query'" wrapper :data="logList" :opActionMap="getLogActionMap"></compLog>
		<vButtonGroup class="text-right"  v-if="!isQuery">
			<vButton v-if="type ==='query' && formData.errorCode!==0" class="margin-right-15" theme="success" @click="reprocess">{{$t('fbb.alloment.reprocess', { defaultValue: '重处理' })}}</vButton>
 			<vButton v-if="type ==='query' && formData.errorCode!==0" class="margin-right-15" theme="info" @click="backToNormal">{{$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' })}}</vButton>
			<vButton @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
			</vButtonGroup>
		<vModal
			v-model="modalProps.show"
			:title="modalProps.title"
			:width="modalProps.width||1000"
			:showFooter="false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</vModal>
	<compModal
                    v-model="modalProps2.show"
                    v-bind="modalProps2"
                    @on-close="modalProps2.show=false"
                >
                    <component
                        v-if="modalProps2.component"
                        :is="modalProps2.component"
                        v-bind="modalProps2.props"
                        v-on="modalProps2.on"
                    />
                </compModal>

		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import {
	HttpSaveOutbound,
	HttpRemoveOutbound,
	HttpSubmitOutbound,
	HttpClearOutbound,
	HttpOutbound,
	HttpAddOutbound,
	HttpOutboundErpSku,
	HttpOnceOutbound,
	HttpImportOutbound,
	HttpDowloadOutboundTemplate,
	HttpPlanBill,
	HttpReprocessPlanBill,
  HttpBackToNormalPlanBill
} from '@/service/allotment';
import { mapGetters } from 'vuex';
import compAllotlist from '../allotlist'
import mixin from '../mixin'
export default {
	mixins: [mixin],
	props: ["activeid"],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compUpload: () => import("@components/templates/upload"),
		compAllotlist,
	},
	data() {
		return {
			loading: false,
			logList: [],
			type: this.$route.params.type,
			id: this.$route.query.id,
			formData: {},
			boundFormData: {},
			dataList: [],//出库明细,
			productList: [],//产品明细,
			boxingList: [],//装箱明细,
			checkData: [],
			modalProps: {
				show: false,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "",
				width: 1000,
				props: {},
				on: {},
			},
				modalProps2: {
				show: false,
				component: "",
				width: 600,
				props: {},
				on: {},
			}
		};
	},
	created() {
		if (this.activeid) {
      /* this.$route.name = "allotUpdateManage"; */
      this.id = this.activeid;
      this.type = "query";
      this.$route.params.type = "query";
      this.$route.query.id = this.activeid;
    }
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getCarrierServiceList','getCusAccountList']),
		getBillStatus() {
			// DRAFT(0, "草稿"),
			// SUBMITTED(5, "已提交"),
			// COMPLETED(70, "已完成"),
			// CANCELED(90, "已取消");
			return [{
				label: this.$t('fbb.inbound.draft', { defaultValue: "草稿" }),
				value: 0
			}, {
				label: this.$t('fbb.alloment.has_commit', { defaultValue: "已提交" }),
				value: 5,
				theme: 'info'
			}, {
				label: this.$t('global.common.finished', { defaultValue: "已完成" }),
				value: 70,
				theme: 'success'
			}, {
				label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
				value: 90,
				theme: 'error'
			}]
		},
		getId() {
			return this.formData.id || this.id;
		},
		 isQuery() {
      if (this.activeid) {
        return false;
      } else {
        return true;
      }
    },
		getBase() {
			const formData = this.formData,
				show = !!this.getId;
			return [
				{
					label: this.$t('fbb.alloment.outbound_order_number', { defaultValue: "调拨出库单号" }),
					key: "transferOutboundNo",
					query: true,
					show: show,
					render: (h) => {
						const { transferOutboundStatus, transferOutboundNo,errorCode } = this.formData;
						const data = this.getBillStatus.find(item => item.value === transferOutboundStatus) || {}
						return <div>{this.formData.transferOutboundNo}<vButton ghost theme={data.theme} style="margin-left:5px;padding:1px 10px;cursor:unset;">{data.label}</vButton><span style="margin-left:5px;color:red;">{this.findRenderLabel(this.getErrorType, errorCode)} </span> </div>
					}
				},
				// {
				// 	label: "状态",
				// 	key: "transferOutboundStatus",
				// 	query: true,
				// 	show: show,
				// 	options: this.getBillStatus
				// },
				{
					label: this.$t('fbb.alloment.alloment_order_number', { defaultValue: "调拨计划单号" }),
					tag: "vInput",
					key: "transferOutboundPlanNo",
					query: show,
					props: {
						suffix: "search",
						readonly: true
					},
					on: {
						'on-icon-click': () => this.handleModal('subTransferPlan')
					},
				}, {
					label: this.$t('fbb.alloment.warehouse_out', { defaultValue: "出库仓库" }),
					query: true,
					key: "orgWarehouseCode",
					// options: formData.orgWarehouseId === undefined ? null : this.getWarehouseAllList
					// valueText: formData.orgWarehouseCode ? `${formData.orgWarehouseCode}(${formData.orgWarehouseTitle})` : ''
				}, {
					label: this.$t('fbb.alloment.carrier_server', { defaultValue: "承运商服务" }),
					tag: "vSelect",
					key: "carrierId",
					options: this.getCarrierServiceList,
					props: {
						filterable: true,
					},
					on: {
						'on-attach': (val) => this.formData.carrierCode = val.carrierServiceCode
					}
				}, {
					label: this.$t('fbb.alloment.onsite_channel', { defaultValue: "ONSITE仓渠道" }),
					query: true,
					key: "onsiteChannel",
					// tag:'vInput',
					// options:this.getCusAccountList,
					// options: formData.orgWarehouseId === undefined ? null : this.getWarehouseAllList
					// valueText: formData.orgWarehouseCode ? `${formData.orgWarehouseCode}(${formData.orgWarehouseTitle})` : ''
				},{
					label: this.$t('', { defaultValue: "托盘数" }),
					query: true,
					show:this.type =="query",
					key: "palletQty",
				},{
					label: this.$t('', { defaultValue: "贴标数" }),
					query: true,
					show:this.type =="query",
					key: "labelQty",
				},{
					label: this.$t('global.common.notes', { defaultValue: "备注" }),
					tag: "vTextarea",
					key: "remark",
					required: false,
				}
			];
		},
		getOutbound() {
			const hasBoxBarcode = !!this.boundFormData.boxBarcode,
				sku = this.boundFormData.sku,
				{ qty = 0, qtyOutbound = 0 } = this.productList.find(item => this.boundFormData.sku == item.sku) || {};
			return [
				{
					label: "ERP SKU",
					key: "sku",
					tag: "vSelect",
					props: {
						filterable: true,
					},
					options: this.productList.map(item => item.sku),
					on: {
						'on-change': (val) => {
							// const data = this.boxingList.find(item => item.sku == val);
							this.boundFormData = { sku: val }
						}
					},
					required: !hasBoxBarcode,
				}, {
					label: this.$t('fbb.alloment.out_bound_number', { defaultValue: "出库数量" }),
					key: "qty",
					tag: "vInputNumber",
					required: !hasBoxBarcode,
					on: {
						'on-change': (val) => {
							if (val > qty - qtyOutbound) this.$VMessage.warning(this.$t('fbb.alloment.outbound_qty_not_allow', { defaultValue: '出库的数量不符' }));
						}
					}
					// props: {
					// 	max: qty - qtyOutbound
					// }
				}, {
					label: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
					key: "boxBarcode",
					required: false,
				}, {
					label: this.$t('fbb.alloment.tray_bar_code', { defaultValue: "托盘码" }),
					key: "trayBarcode",
					required: false,
				}, {
					label: "Tracking  NO",
					key: "trackingNo",
					required: false,
				}, {
                    // label: "计划数/已出数",
                    label:  `${this.$t('fbb.alloment.plan_qty', { defaultValue: '计划数' })}/${this.$t('fbb.alloment.has_outbound_qty', { defaultValue: '已出数' })}`,
					query: true,
					valueText: qty ? `${qty}/${qtyOutbound}` : '-'
				}
			];
		},
		getProcuctColumns() {
			return [{
				title: '#',
				type: 'index',
				width: 100,
				align: 'center',
			}, {
				title: 'ERP SKU',
				key: 'sku',
			}, {
				title: this.$t('fbb.alloment.plan_out_bound', { defaultValue: '计划出库数量' }),
				key: 'qty',
			}, {
				title: this.$t('fbb.alloment.box_number', { defaultValue: '装箱数量' }),
				key: 'qtyPacked',
			}, {
				title: this.$t('fbb.alloment.has_outbound_number', { defaultValue: '已出库数量' }),
				key: 'qtyOutbound',
			}]
		},
		getOutColumns() {
			return [{
				type: 'selection',
				width: this.type === 'query' ? 0 : 40,
				align: 'center',
				formName: 'id'
			}, {
				title: '#',
				type: 'index',
				width: 40,
				align: 'center',
			}, {
				title: 'Tracking  NO',
				key: "trackingNo"
			}, {
				title: this.$t('fbb.inbound.case_code', { defaultValue: '箱码' }),
				key: 'cartonBarcode',
			}, {
				title: 'ERP SKU',
				key: 'sku',
			}, {
				title: this.$t('fbb.alloment.has_outbound_number', { defaultValue: '出库数量' }),
				key: 'qty',
			}, {
				title: this.$t('fbb.alloment.tray_bar_code', { defaultValue: '托盘码' }),
				key: 'palletBarcode',
			}, {
				title: this.$t('fbb.alloment.outer_box_weight', { defaultValue: '外箱毛重' }) + '（g）',
				key: 'cartonGrossWeight',
			}, {
				title: this.$t('fbb.alloment.outer_box_size', { defaultValue: '外箱长*宽*高' }) + '（cm）',
				key: 'cartonLength',
				render(h, { row }) {
					return <div>
						{row.length}*
							{row.width}*
							{row.height}(cm*cm*cm)
							</div>
				}
			}, {
				title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
				key: 'createdAt',
			}]
		},
	},
	methods: {
		//获取选中出库数据
		setCheckData(rows, val) {
			this.checkData = val;
		},
		// 详情操作
		handleModal(type) {
			//装箱明细
			if (type === 'boxing') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.alloment.box_detail', { defaultValue: '装箱明细' }),
					component: "vTableSimple",
					props: {
						columns: this.getBoxingColumns,
						data: this.boxingList
					}
				}
				return;
			}
			//导入出库明细
			if (type === 'upload') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
					component: "compUpload",
					width: 520,
					props: {
						ajaxRequest: HttpImportOutbound,
						name: "multipartFile",
						data: {
							transferOutboundPlanId: this.formData.transferOutboundPlanId,
							transferOutboundId: this.getId,
						},
						download: () => {
							this.handleWebfs("/static/template/Transfer_Outbound_Items.xls", {}, {
								executor: 'download',
								type: 'url'
							});
							// this.handleWebfs(process.env.VUE_APP_APIURL_FBB+'/api/v2/TransferOutbound/transferOutboundItemTemplate', {}, 'download');
						}
					},
					on: {
						'on-success': () => {
							this.modalProps.show = false;
							this.getDetail();
						}
					}
				}
				return;
			}
			if (type === 'subTransferPlan') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.alloment.alloment_order_number', { defaultValue: '调拨计划单号' }),
					component: "compAllotlist",
					props: {
						initFormData: {
							'search[IN_subTransferPlanStatus]': '9,10,15'
						}
					},
					on: {
						'on-data': (row) => {
							console.log(row)
							this.formData = {
								...this.formData,
								subTransferPlanId: row.id,
								transferOutboundPlanNo: row.subTransferPlanNo,
								orgWarehouseId: row.orgWarehouseId,
								orgWarehouseCode: row.orgWarehouseCode,
								onsiteChannel:row.onsiteChannel
								// orgWarehouseTitle: row.orgWarehouseTitle,
							}
							this.productList = row.transferOutboundPlanItemList || [];
							this.boxingList = row.transferOutboundPlanBoxItemList || [];
							this.modalProps.show = false;
						}
					}
				}
				return;
			}
		},
		cancel() {
			this.$router.push({
				name: "allotOutbound"
			});
			this.$emit("on-update");
		},
		reprocess(){
          this.operate = {
                show: true,
                alert: "error",
                title: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                width: 400,
                showDesc: true,
                params: {
                    id:  this.id,
                    type:3
                },
				ajaxRequest: HttpReprocessPlanBill,
				callback: this.cancel
          };
    },
    backToNormal(){
          this.operate = {
                show: true,
                alert: "info",
                title: this.$t('fbb.alloment.back_to_normal', { defaultValue: "忽略异常" }),
                width: 400,
                showDesc: true,
                params: {
                    id: this.id,
                    type:3
                },
				ajaxRequest: HttpBackToNormalPlanBill,
				callback: this.cancel
          };
    },
		//获取调拨计划单详情数据
		getTransferPlanDetail() {
			/* if (this.type !== 'edit') return; */
			this.loading = true;
			HttpPlanBill({ id: this.formData.transferOutboundPlanId }).then(res => {
				const body = res.data.transferOutboundPlanEntity || {};
				this.productList = body.transferOutboundPlanItemList || [];
				this.boxingList = body.transferOutboundPlanBoxItemList || [];
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		getDetail() {
			if (!this.getId) return;
			this.loading = true;
			HttpOutbound({
				transferOutboundId: this.getId
			}).then(res => {
				this.handleResponse(res.data)
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		handleResponse(data) {
			const body = data.transferOutboundEntity || {};
			const entity = data.transferOutboundPlanEntity || {};
			this.loading = false;
			this.dataList = body.transferOutboundItemEntityList || [];
			delete body.transferOutboundItemEntityList;
			this.formData = body;
			this.formData.subTransferPlanId = body.transferOutboundPlanId;
			this.formData.transferOutboundPlanId = entity.id;
			this.logList = data.orderLogEntityList;
			this.getTransferPlanDetail();
		},
		async addItem() {
			const valid = await this.$refs.bound.validate();
			if (!valid) return;
			this.loading = true;
			HttpAddOutbound({
				transferOutboundId: this.getId,
				transferOutboundNo: this.formData.transferOutboundNo,
				transferOutboundPlanId: this.formData.transferOutboundPlanId,
				...this.boundFormData
			}).then(res => {
				this.loading = false;
				this.getDetail();
				this.boundFormData = {};
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		clearAll() {
			this.modalProps2={
                    show: true,//显示弹框
                    width:400, //弹框宽度
				    alert: 'success',//简洁模式主题和component模式互斥，
                    params: { transferOutboundId: this.getId},//接口参数
                    ajaxRequest: HttpClearOutbound,//接口
                    desc: this.$t('fbb.alloment.confirm_clear_all_data', { defaultValue: '是否确认清空所有数据？' }),
                    //不显示描述，
                    title: this.$t('global.common.clear', { defaultValue: '清空' }),//标题，
                    callback: ()=>{
						this.getDetail();
					},//成功回调函数,
                };
		/* 	this.loading = true;
			HttpClearOutbound({
				transferOutboundId: this.getId
			}).then(res => {
				this.loading = false;
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			}) */
		},
		removeItems() {
			const ids = this.checkData.join(',');
			if (!ids) {
				this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
				return;
			}
			this.loading = true;
			HttpRemoveOutbound({
				ids,
				transferOutboundId: this.getId
			}).then(res => {
				this.loading = false;
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//提交完成
		submitComplete() {
			if (!this.dataList.length) return this.$VMessage.warning(this.$t('fbb.alloment.add_outbound_detail', { defaultValue: '请添加出库明细' }));
			this.loading = true;
			HttpSubmitOutbound({
				transferOutboundId: this.getId,
			}).then(res => {
				this.loading = false;
				this.cancel();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		async submitSave(type) {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			// const data = {
			// 	transferOutboundPlanId: this.formData.transferOutboundPlanId,
			// 	carrierCode: this.formData.carrierCode,
			// 	carrierId: this.formData.carrierId,
			// 	remark: this.formData.remark || "",
			// 	id:this.getId
			// }
			const id = this.getId;
			HttpSaveOutbound({
				subTransferPlanId: this.formData.subTransferPlanId,
				carrierCode: this.formData.carrierCode,
				carrierId: this.formData.carrierId,
				remark: this.formData.remark || "",
				id
			}).then(res => {
				this.loading = false;
				HttpOutbound({
				transferOutboundId: res.data.id
			}).then(res => {
				this.handleResponse(res.data)
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
			/* 	this.handleResponse({ transferOutboundEntity: res.data }); */
				if (type === 'complete') return this.submitComplete();
				if (id) {
					this.$VMessage.success(`${this.$t('fbb.allotmant.inbound', { defaultValue: '调拨出库单' })}:${this.formData.transferOutboundNo}`);
					this.cancel();
				}
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		onceSubmit() {
			this.loading = true;
			HttpOnceOutbound({
				transferOutboundPlanId: this.formData.transferOutboundPlanId,
				transferOutboundId: this.getId,
				subTransferPlanId: this.formData.subTransferPlanId
			}).then(res => {
				this.loading = false;
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
	}
};
</script>
